import React from 'react';
import { useSelector } from 'react-redux';
import { authUserSelector } from '../../../../redux/auth/selectors/authUser';
import ProductDetailBuyer from '../../buyer/ProductDetail';
import ProductDetailSupplier from '../../supplier/ProductDetail';
import { authenticatingSelector } from '~redux/auth/selectors/authenticating';
import LoadingContainer from '~view/widgets/LoadingContainer';

type ProductDetailsProps = {};

const ProductDetails: React.FC<ProductDetailsProps> = () => {
  const authenticating = useSelector(authenticatingSelector);
  const authUser = useSelector(authUserSelector);
  const profile = authUser?.attributes.profile;
  const sub = authUser?.attributes.sub;

  if (authenticating) {
    return <LoadingContainer isLoading />;
  }

  if (['supplier', 'admin'].includes(profile ?? '')) {
    return <ProductDetailSupplier sub={sub} admin={profile === 'admin'} />;
  }

  return <ProductDetailBuyer />;
};

export default ProductDetails;
